import axios from 'axios';
import _ from 'lodash';
import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';


const headers = {'Content-Type': 'application/json'}
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }


/*
export function loadOrderderNow(rqValuesSpaceIdMulti){
    console.log(rqValuesSpaceIdMulti)
    let rqValuesSpaceId = -1
    if(rqValuesSpaceIdMulti && rqValuesSpaceIdMulti.length > 1){
        let itemId = rqValuesSpaceIdMulti[1];
       
        rqValuesSpaceId = itemId
    }
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + rqValuesSpaceId)
    console.log(rqValuesSpaceId)
    return dispatch => {
        dispatch(svLoadOrderdetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/myreervationssv/detail`
        let body = {
            "docId":[],
            "hsetname":"HotelInvDB"
        }
        body.docId.push(rqValuesSpaceId)
          
        axios.post(url, body, {headers:headers})
        .then(
            r2 => {
                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                        "resort_name": "Cambria Hotel Orlando Airport",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "stayDet": "6 nights",
                        "num_reviews": 101,
                        "amenity_name": [
                            "HotTub",
                            "Spa",
                            "Swimming pool",
                            "Laundry"
                        ],
                        "num_reviews_label": "Good, ",
                        "rating_detail":" Excellebt, 9.1",
                        "num_reviews_detail": "Good, 101 reviews"
                       
                    },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
                if(r2.data.svo.hits.hits.length>0){
                    const ar = r2.data.svo.hits.hits
                    let recs_with_duplicate_ar = []
                    let space_rec = {}
                   
                    var item , ob, sod, upperOb
                    
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        sod =  _.clone(ob)

                        

                        recs_with_duplicate_ar.push(sod)
                    });
                    space_rec = recs_with_duplicate_ar[0]
                    my_data_review_tp.booking = space_rec
                    let soj = space_rec
                    let svr_location = {
                        "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                        "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                        "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                        "county": soj['county'] ? soj['county'] : "albanyt",
                        "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                        "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                        "country": soj['country_name'] ? soj['country_name'] : "usa",
                       "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                       "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                        
                       "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                       "state":soj['state'] ? soj['state'] : "NY"

                    }

                  let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                  my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                  let amenity_name = [
                    "300 feet elevator",
                    "air conditioning",
                    "private bathroom"
                ]
                  my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name

                   
                }
                if(r2.data.dbo){
                    let ob2,sod2, upperOb2
                    ob2 = r2.data.dbo
                    let cost = ob2.salePrice || 100
                    let totaltax = 0
                   
                    let currencycode='$',  citytaxPercent=6.5,maintax =0, citytax=0
                    let taxPercent  = (ob2.taxPercent? ob2.taxPercent:6)
                     citytaxPercent  = (ob2.cityTaxPercent? ob2.cityTaxPercent:6.5)
                    

                     sod2 =  _.clone(ob2)
                     maintax = cost * taxPercent /100
                     maintax = Number(maintax.toFixed(2))
                     citytax = cost * citytaxPercent /100
                    citytax = citytax.toFixed(2)
                    citytax =Number(citytax)
                    totaltax = maintax + citytax
                    totaltax = totaltax.toFixed(2)
                    totaltax = Number(totaltax)
                    let fullPriceWithtax = totaltax + cost
                    let depositWithCurrency = ''

                    if(sod2.currency == 'USD'){
                        currencycode = '$' 
                       
                    }else{
                        currencycode = sod2.currency
                    }
                    depositWithCurrency = currencycode + sod2.deposit
                   
                    let deposit


                    
                    let priceObOld= {

                        "total": currencycode+fullPriceWithtax,
                        "depositValue":depositWithCurrency,
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": currencycode+totaltax,
                            "maintax":  currencycode+maintax,
                            "citytax":  currencycode+citytax,
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    }

                    let priceOb = {
                        "discountPrice": 0,
                        "discountPercent": 0,
                        "taxPercent": 6.5,
                        "cityTaxPercent": 6,
                        "deposit": null,
                        "depositPercent": null,
                        "basePrice": 400,
                        "salePrice": 900,
                        "currency": "USD",
                        "depositLocale": null,
                        "basePriceLocale": "$800.00",
                        "salePriceLocale": "$1000.00",
                        "taxTotal": "$125.00",
                        "maintax": "$35.00",
                        "citytax": "$30.00",
                        "total": "$934.00",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "depositValue": "$200.00"
                    }
                    
                    if(ob2.price  ){
                        priceOb = ob2.price
                        my_data_review_tp.price = priceOb
                    }else{
                        my_data_review_tp.price = priceOb
                    }
                   
                    
                    my_data_review_tp.orderItem = sod2

                    const comData = {my_data_review:my_data_review_tp}
                    dispatch(geLoadOrderdetSuccess(comData))

                    
                 } else {
                    const comData = {my_data_review:my_data_review_tp}
                    dispatch(geLoadOrderdetSuccess(comData))
                }

               
            }
        ).catch(
            e=>dispatch(getLoadOrderdetError(e))
            
        )
    }
}
*/
export function loadOrderderNow(rqValuesSpaceIdMulti,hdr, relUrl){
    console.log(rqValuesSpaceIdMulti)
    let rqValuesSpaceId = -1
    if(rqValuesSpaceIdMulti && rqValuesSpaceIdMulti.length > 1){
        let itemId = rqValuesSpaceIdMulti[1];
       
        rqValuesSpaceId = itemId
    }
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + rqValuesSpaceId)
    console.log(rqValuesSpaceId)
    return dispatch => {
        dispatch(svLoadOrderdetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/myreervationssv/detail`
        let body = {
            "docId":[],
            "hsetname":"HotelInvDB"
        }
        body.docId.push(rqValuesSpaceId)
          
        const svurl = relUrl ? `${SV_SOJ_ORCMOCK_ADDRESS}/${relUrl}` :url
        const svhdr = hdr ? hdr: headers 
        axios.post(svurl, body, {headers:svhdr})

        .then(
            r2 => {
                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                        "resort_name": "Cambria Hotel Orlando Airport",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "stayDet": "6 nights",
                        "num_reviews": 101,
                        "amenity_name": [
                            "HotTub",
                            "Spa",
                            "Swimming pool",
                            "Laundry"
                        ],
                        "num_reviews_label": "Good, ",
                        "rating_detail":" Excellebt, 9.1",
                        "num_reviews_detail": "Good, 101 reviews"
                       
                    },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
                if(r2.data.svo.hits.hits.length>0){
                    const ar = r2.data.svo.hits.hits
                    let recs_with_duplicate_ar = []
                    let space_rec = {}
                   
                    var item , ob, sod, upperOb
                    
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        sod =  _.clone(ob)

                        

                        recs_with_duplicate_ar.push(sod)
                    });
                    space_rec = recs_with_duplicate_ar[0]
                    my_data_review_tp.booking = space_rec
                    let soj = space_rec
                    let svr_location = {
                        "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                        "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                        "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                        "county": soj['county'] ? soj['county'] : "albanyt",
                        "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                        "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                        "country": soj['country_name'] ? soj['country_name'] : "usa",
                       "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                       "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                        
                       "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                       "state":soj['state'] ? soj['state'] : "NY"

                    }

                  let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                  my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                  let amenity_name = [
                    "300 feet elevator",
                    "air conditioning",
                    "private bathroom"
                ]
                  my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name

                   
                }
                if(r2.data.dbo){
                    let ob2,sod2, upperOb2
                    ob2 = r2.data.dbo
                    let cost = ob2.salePrice || 100
                    let totaltax = 0
                   
                    let currencycode='$',  citytaxPercent=6.5,maintax =0, citytax=0
                    let taxPercent  = (ob2.taxPercent? ob2.taxPercent:6)
                     citytaxPercent  = (ob2.cityTaxPercent? ob2.cityTaxPercent:6.5)
                    

                     sod2 =  _.clone(ob2)
                     maintax = cost * taxPercent /100
                     maintax = Number(maintax.toFixed(2))
                     citytax = cost * citytaxPercent /100
                    citytax = citytax.toFixed(2)
                    citytax =Number(citytax)
                    totaltax = maintax + citytax
                    totaltax = totaltax.toFixed(2)
                    totaltax = Number(totaltax)
                    let fullPriceWithtax = totaltax + cost
                    let depositWithCurrency = ''

                    if(sod2.currency == 'USD'){
                        currencycode = '$' 
                       
                    }else{
                        currencycode = sod2.currency
                    }
                    depositWithCurrency = currencycode + sod2.deposit
                   
                    let deposit


                    
                    let priceObOld= {

                        "total": currencycode+fullPriceWithtax,
                        "depositValue":depositWithCurrency,
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": currencycode+totaltax,
                            "maintax":  currencycode+maintax,
                            "citytax":  currencycode+citytax,
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    }

                    let priceOb = {
                        "discountPrice": 0,
                        "discountPercent": 0,
                        "taxPercent": 6.5,
                        "cityTaxPercent": 6,
                        "deposit": null,
                        "depositPercent": null,
                        "basePrice": 400,
                        "salePrice": 900,
                        "currency": "USD",
                        "depositLocale": null,
                        "basePriceLocale": "$800.00",
                        "salePriceLocale": "$1000.00",
                        "taxTotal": "$125.00",
                        "maintax": "$35.00",
                        "citytax": "$30.00",
                        "total": "$934.00",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "depositValue": "$200.00"
                    }
                    
                    if(ob2.price  ){
                        priceOb = ob2.price
                        my_data_review_tp.price = priceOb
                    }else{
                        my_data_review_tp.price = priceOb
                    }
                   
                    
                    my_data_review_tp.orderItem = sod2

                    const comData = {my_data_review:my_data_review_tp}
                    dispatch(geLoadOrderdetSuccess(comData))

                    
                 } else {
                    const comData = {my_data_review:my_data_review_tp}
                    dispatch(geLoadOrderdetSuccess(comData))
                }

               
            }
        ).catch(
            e=>dispatch(getLoadOrderdetError(e))
            
        )
    }
}


export function loadOrderderNowSecure(rqValuesSpaceIdMulti, svtv){
    console.log(rqValuesSpaceIdMulti)
    let rqValuesSpaceId = -1
    
   
    if(_.isArray(rqValuesSpaceIdMulti) && rqValuesSpaceIdMulti.length > 1){
        let itemId = rqValuesSpaceIdMulti[1];
     
       rqValuesSpaceId = itemId
    }else{
        //this is wher actuall code comes
        //we are passed just as Id not array with [customerId, orderid]
        //rqValuesSpaceId = 97
         rqValuesSpaceId = rqValuesSpaceIdMulti
    }
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + rqValuesSpaceId)
    console.log(rqValuesSpaceId)
    return dispatch => {
        dispatch(svLoadOrderdetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/myreervationssv/detailSecure`
        let body = {
            "docId":[],
            "hsetname":"HotelInvDB"
        }
        body.docId.push(rqValuesSpaceId)
          
        const authtoken = `Bearer ${svtv}`
        const svheaders = { 'Authorization': authtoken,
        'Content-Type': 'application/json' };
      axios.post(url, body, {headers:svheaders})
        .then(
            r2 => {
                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                        "resort_name": "Cambria Hotel Orlando Airport",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "stayDet": "6 nights",
                        "num_reviews": 101,
                        "amenity_name": [
                            "HotTub",
                            "Spa",
                            "Swimming pool",
                            "Laundry"
                        ],
                        "num_reviews_label": "Good, ",
                        "rating_detail":" Excellebt, 9.1",
                        "num_reviews_detail": "Good, 101 reviews"
                       
                    },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
                if( (r2.data.dbo) && (r2.data.dbo.status)  && (r2.data.dbo.status != 200)){
                    let eeb = {}
                       
                    
                    eeb.errob = {
                        "timestamp": "2024-08-23T02:27:18.038+0000",
                        "status": 500,
                        "error": "Internal Server Error",
                        "message": "500 null",
                        "path": "/accountclient/svaddressDetailPost"
                    }
                    dispatch(getLoadOrderdetError(eeb))
                }else{

                    //svdet start
                if(r2.data.svo.hits.hits.length>0){
                    const ar = r2.data.svo.hits.hits
                    let recs_with_duplicate_ar = []
                    let space_rec = {}
                   
                    var item , ob, sod, upperOb
                    
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        sod =  _.clone(ob)

                        

                        recs_with_duplicate_ar.push(sod)
                    });
                    space_rec = recs_with_duplicate_ar[0]
                    my_data_review_tp.booking = space_rec
                    let soj = space_rec
                    let svr_location = {
                        "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                        "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                        "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                        "county": soj['county'] ? soj['county'] : "albanyt",
                        "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                        "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                        "country": soj['country_name'] ? soj['country_name'] : "usa",
                       "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                       "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                        
                       "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                       "state":soj['state'] ? soj['state'] : "NY"

                    }

                  let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                  my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                  let amenity_name = [
                    "300 feet elevator",
                    "air conditioning",
                    "private bathroom"
                ]
                  my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name

                   
                }
                if(r2.data.dbo){
                    let ob2,sod2, upperOb2
                    ob2 = r2.data.dbo
                    let cost = ob2.salePrice || 100
                    let totaltax = 0
                   
                    let currencycode='$',  citytaxPercent=6.5,maintax =0, citytax=0
                    let taxPercent  = (ob2.taxPercent? ob2.taxPercent:6)
                     citytaxPercent  = (ob2.cityTaxPercent? ob2.cityTaxPercent:6.5)
                    

                     sod2 =  _.clone(ob2)
                     maintax = cost * taxPercent /100
                     maintax = Number(maintax.toFixed(2))
                     citytax = cost * citytaxPercent /100
                    citytax = citytax.toFixed(2)
                    citytax =Number(citytax)
                    totaltax = maintax + citytax
                    totaltax = totaltax.toFixed(2)
                    totaltax = Number(totaltax)
                    let fullPriceWithtax = totaltax + cost
                    let depositWithCurrency = ''

                    if(sod2.currency == 'USD'){
                        currencycode = '$' 
                       
                    }else{
                        currencycode = sod2.currency
                    }
                    depositWithCurrency = currencycode + sod2.deposit
                   
                    let deposit


                    
                    let priceObOld= {

                        "total": currencycode+fullPriceWithtax,
                        "depositValue":depositWithCurrency,
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": currencycode+totaltax,
                            "maintax":  currencycode+maintax,
                            "citytax":  currencycode+citytax,
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    }

                    let priceOb = {
                        "discountPrice": 0,
                        "discountPercent": 0,
                        "taxPercent": 6.5,
                        "cityTaxPercent": 6,
                        "deposit": null,
                        "depositPercent": null,
                        "basePrice": 400,
                        "salePrice": 900,
                        "currency": "USD",
                        "depositLocale": null,
                        "basePriceLocale": "$800.00",
                        "salePriceLocale": "$1000.00",
                        "taxTotal": "$125.00",
                        "maintax": "$35.00",
                        "citytax": "$30.00",
                        "total": "$934.00",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "depositValue": "$200.00"
                    }
                    
                    if(ob2.price  ){
                        priceOb = ob2.price
                        my_data_review_tp.price = priceOb
                    }else{
                        my_data_review_tp.price = priceOb
                    }
                   
                    
                    my_data_review_tp.orderItem = sod2

                    const comData = {my_data_review:my_data_review_tp}
                    dispatch(geLoadOrderdetSuccess(comData))

                    
                 } else {
                    const comData = {my_data_review:my_data_review_tp}
                    dispatch(geLoadOrderdetSuccess(comData))
                }
                //svdet end
                }
                
               
            }
        ).catch(
            e=>dispatch(getLoadOrderdetError(e))
            
        )
    }
}

  export function loadOrderderNow_Bad(rqValuesSpaceId){

    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
    return dispatch => {
        dispatch(svLoadOrderdetBegin())
        //const url = 'http://localhost:8086/myreervationssv/detail'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spaceLoadReview`
        const body = {
            "query": {
              "match": {
                "SPACEKEY.keyword": (rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
              }
            }
          }

        const bodyBad = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword":(rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
                            }
                        }
                    ]
                }
            }
         }

        
          
        //http://localhost:8086/myreervationssv/detail
        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/myreervationssv/detail`
        const bodyDB = {
            "docId":["1"],
            "hsetname":"HotelInvDB"
        }

        axios.all([
            axios.post(url, body, {headers:headers}),
            axios.post(urlSpacePrice,bodyDB, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                        "resort_name": "Cambria Hotel Orlando Airport",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "stayDet": "6 nights",
                        "num_reviews": 101,
                        "amenity_name": [
                            "HotTub",
                            "Spa",
                            "Swimming pool",
                            "Laundry"
                        ],
                        "num_reviews_label": "Good, ",
                        "rating_detail":" Excellebt, 9.1",
                        "num_reviews_detail": "Good, 101 reviews"
                       
                    },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
                if(r.data){

                    
                    
                     if(r.data.hits.hits.length>0){
                         const ar = r.data.hits.hits
                         let recs_with_duplicate_ar = []
                         let space_rec = {}
                        
                         var item , ob, sod, upperOb
                         
                         ar.forEach(a_rec => {
                             item = {}
                            
                             upperOb = a_rec['_source']
                             ob =lowercaseKeys(upperOb)
     
                             sod =  _.clone(ob)
     
                             
     
                             recs_with_duplicate_ar.push(sod)
                         });
                         space_rec = recs_with_duplicate_ar[0]
                         my_data_review_tp.booking = space_rec
                         let soj = space_rec
                         let svr_location = {
                             "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                             "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                             "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                             "county": soj['county'] ? soj['county'] : "albanyt",
                             "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                             "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                             "country": soj['country_name'] ? soj['country_name'] : "usa",
                            "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                            "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                             
                            "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                            "state":soj['state'] ? soj['state'] : "NY"
 
                         }
 
                       let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                       my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                       let amenity_name = [
                         "300 feet elevator",
                         "air conditioning",
                         "private bathroom"
                     ]
                       my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name
 
                        
                     }
                     else {
                        console.log('getting error * review Load Action')
                        
                     }
 
                     const comData = {my_data_review:my_data_review_tp}
                     
                     if(r2.data.dbo){
                        let ob2,sod2, upperOb2
                        ob2 = r2.data.dbo
                        let cost = ob2.salePrice || 100
                        let totaltax = 0
                       
                        let currencycode='$',  citytaxPercent=6.5,maintax =0, citytax=0
                        let taxPercent  = (ob2.taxPercent? ob2.taxPercent:6)
                         citytaxPercent  = (ob2.cityTaxPercent? ob2.cityTaxPercent:6.5)
                        

                         sod2 =  _.clone(ob2)
                         maintax = cost * taxPercent /100
                         maintax = Number(maintax.toFixed(2))
                         citytax = cost * citytaxPercent /100
                        citytax = citytax.toFixed(2)
                        citytax =Number(citytax)
                        totaltax = maintax + citytax
                        totaltax = totaltax.toFixed(2)
                        totaltax = Number(totaltax)
                        let fullPriceWithtax = totaltax + cost

                        if(sod2.currency == 'DL'){
                            currencycode = '$'
                        }else{
                            currencycode = sod2.currency
                        }
                        let priceOb= {

                            "total": currencycode+fullPriceWithtax,
                            "depositValue":"0",
                            "depositName":"Damage Deposit (Fully refundable)",
                            "currency": "usd",
                            "tax": {
                               
                                "taxTotal": currencycode+totaltax,
                                "maintax":  currencycode+maintax,
                                "citytax":  currencycode+citytax,
                    
                                "taxPercent": "6",
                                "citytaxPercent": "6.5"
                            }
                        }

                        my_data_review_tp.price = priceOb
                        my_data_review_tp.orderItem = sod2


                     }
                    
                    
                     dispatch(geLoadOrderdetSuccess(comData))
                 }
                 else {
                     const comData = {my_data_review:my_data_review_tp}
                     dispatch(geLoadOrderdetSuccess(comData))
                 }

                   
                }
            )
            /*svend*/
          
        ).catch(
            e=>dispatch(getLoadOrderdetError(e))
        )
    }

}

export const svLoadOrderdetBegin = () => dispatch => {
    dispatch({
        type:'GET_ORDERDET_BEGIN'
        
    })
}


export const geLoadOrderdetSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_ORDERDET_SUCCESS',
        payload: data
    })
}

export const getLoadOrderdetError = (e) =>dispatch => {
    dispatch({
        type:'GET_ORDERDET_ERROR',
        payload:e
    })
}






export function loadOrderderNowOLD(rqValuesSpaceId){

    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
    return dispatch => {
        dispatch(svLoadOrderdetBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spaceLoadReview`
        const body = {
            "query": {
              "match": {
                "SPACEKEY.keyword": (rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
              }
            }
          }

        const bodyBad = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword":(rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
                            }
                        }
                    ]
                }
            }
         }

        
          
        
        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/sojourPriceView`

        axios.all([
            axios.post(url, body, {headers:headers}),
            axios.post(urlSpacePrice,body, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                        "resort_name": "Cambria Hotel Orlando Airport",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "stayDet": "6 nights",
                        "num_reviews": 101,
                        "amenity_name": [
                            "HotTub",
                            "Spa",
                            "Swimming pool",
                            "Laundry"
                        ],
                        "num_reviews_label": "Good, ",
                        "rating_detail":" Excellebt, 9.1",
                        "num_reviews_detail": "Good, 101 reviews"
                       
                    },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
                if(r.data){

                    
                    
                     if(r.data.hits.hits.length>0){
                         const ar = r.data.hits.hits
                         let recs_with_duplicate_ar = []
                         let space_rec = {}
                        
                         var item , ob, sod, upperOb
                         
                         ar.forEach(a_rec => {
                             item = {}
                            
                             upperOb = a_rec['_source']
                             ob =lowercaseKeys(upperOb)
     
                             sod =  _.clone(ob)
     
                             
     
                             recs_with_duplicate_ar.push(sod)
                         });
                         space_rec = recs_with_duplicate_ar[0]
                         my_data_review_tp.booking = space_rec
                         let soj = space_rec
                         let svr_location = {
                             "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                             "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                             "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                             "county": soj['county'] ? soj['county'] : "albanyt",
                             "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                             "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                             "country": soj['country_name'] ? soj['country_name'] : "usa",
                            "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                            "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                             
                            "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                            "state":soj['state'] ? soj['state'] : "NY"
 
                         }
 
                       let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                       my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                       let amenity_name = [
                         "300 feet elevator",
                         "air conditioning",
                         "private bathroom"
                     ]
                       my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name
 
                        
                     }
                     else {
                        console.log('getting error * review Load Action')
                        
                     }
 
                     const comData = {my_data_review:my_data_review_tp}
                     
                     if(r2.data.hits.hits.length>0){
                        let ob2,sod2, upperOb2
                        const ar2 = r2.data.hits.hits
                        const a_rec2 = ar2[0] || {}
                        upperOb2 = a_rec2['_source']
                        ob2 =lowercaseKeys(upperOb2)

                        sod2 =  _.clone(ob2)
                        let cost = sod2.productcostamount || 100
                        let totaltax = 0
                       
                        let currencycode='$', taxPercent = 6,citytaxPercent=6.5, maintax =0, citytax=0
                        
                        maintax = cost * taxPercent /100
                        maintax = Number(maintax.toFixed(2))
                        
                        citytax = cost * citytaxPercent /100
                        citytax = citytax.toFixed(2)
                        citytax =Number(citytax)
                        totaltax = maintax + citytax
                        totaltax = totaltax.toFixed(2)
                        totaltax = Number(totaltax)

                        let fullPriceWithtax = totaltax + cost

                        if(sod2.currencycode == 'DL'){
                            currencycode = '$'
                        }else{
                            currencycode = sod2.currencycode
                        }
                        let priceOb= {

                            "total": currencycode+fullPriceWithtax,
                            "depositValue":"0",
                            "depositName":"Damage Deposit (Fully refundable)",
                            "currency": "usd",
                            "tax": {
                               
                                "taxTotal": currencycode+totaltax,
                                "maintax":  currencycode+maintax,
                                "citytax":  currencycode+citytax,
                    
                                "taxPercent": "6",
                                "citytaxPercent": "6.5"
                            }
                        }

                        my_data_review_tp.price = priceOb
                        
                        
                       
                    }
                    
                     dispatch(geLoadOrderdetSuccess(comData))
                 }
                 else {
                     const comData = {my_data_review:my_data_review_tp}
                     dispatch(geLoadOrderdetSuccess(comData))
                 }

                   
                }
            )
            /*svend*/
          
        ).catch(
            e=>dispatch(getLoadOrderdetError(e))
        )
    }

}